import React, { useEffect, useState } from 'react';
import { Callout, H5, Intent } from '@blueprintjs/core';
import usersApi from 'ecommerce/api/users';
import uuid from 'utils/uuid';
import { formatDate, parseDate } from 'utils/format';

import useEditorContext from '../../../context/editorContext';
import useEditorItemContext from '../../../context/editorItemContext';
import NumberOfGenerationsSelect from '../../../components/ancestry/numberOfGenerationsSelect';
import EventListCard from '../../components/eventListCard';
import EventFormControl from '../../components/eventFormControl';

const CreationsPanel = () => {
  const { product, item } = useEditorItemContext();
  const editorContext = useEditorContext();

  const [error, setError] = useState();

  const [orders, setOrders] = useState();
  const [selectedOrder, setSelectedOrder] = useState();

  const [events, setEvents] = useState();

  useEffect(() => {
    (async () => {
      const { data, error: ordersError } = await usersApi(editorContext.accessToken).getSkuOrders(
        product.id,
      );

      if (ordersError) {
        setError(ordersError);
        return;
      }

      setOrders(data);
      setSelectedOrder(data[0]);
    })();
  }, []);

  useEffect(() => {
    if (selectedOrder) {
      (async () => {
        const { data, error: dataError } = await usersApi(
          editorContext.accessToken,
        ).getProcessedProductData(selectedOrder.item_id);

        if (dataError) {
          setError(dataError);
          return;
        }

        if (data.additional_info?.events) {
          setEvents(
            data.additional_info?.events
              .filter(event => event.type !== 'holidays')
              .sort((a, b) => {
                const dateA = formatDate(parseDate(a.date, 'YYYY-MM-DD'), 'MM-DD');
                const dateB = formatDate(parseDate(b.date, 'YYYY-MM-DD'), 'MM-DD');
                return dateA < dateB ? -1 : 1;
              }),
          );
        } else {
          setEvents([]);
        }
      })();
    }
  }, [selectedOrder]);

  const handleOnAddEvents = selectedEvents => {
    editorContext.addEvents(
      item.id,
      selectedEvents.map(event => ({
        key: uuid(),
        date: event.date,
        description: event.description,
        type: 'creations',
      })),
    );
  };

  if (!orders) {
    return null;
  }

  if (error) {
    return (
      <>
        <Callout intent={Intent.DANGER}>
          Oh no! We’re sorry, something has gone wrong. We’re working to fix the issue. In the
          meantime, you could try refreshing your page.
        </Callout>
      </>
    );
  }

  if (orders.length === 0) {
    return <H5>Sorry, we didn&apos;t find any previous creation.</H5>;
  }

  return (
    <>
      <H5 className="mb-3">Select events from your previous creations</H5>

      <EventFormControl label="Select order">
        <NumberOfGenerationsSelect
          fill
          values={orders}
          selectedValue={selectedOrder}
          onChange={setSelectedOrder}
          mask={order =>
            `${formatDate(parseDate(order.created_at), 'MMM D, YYYY')} ${order.item_id}`
          }
        />
      </EventFormControl>

      <EventListCard events={events} onAddEvents={handleOnAddEvents} />
    </>
  );
};

export default CreationsPanel;
